import React, { useEffect, useState } from "react";
import "../../style/navigationBar.css";

export default function NavigationBar(props: any) {
  const [lovdataBookLink, setLovdataBookLink] = useState<string>("");

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT == "production") {
      setLovdataBookLink("https://lovdata.no/pro/#document/KARNOV/" + props.bookInfo.BookId);
    } else {
      setLovdataBookLink("https://stage.lovdata.no:8087/pro/#document/KARNOV/" + props.bookInfo.BookId);
    }
  }, [props.bookInfo.BookId]);

  return (
    <>
      <div className="NavigationBar-Container">
        <div className="NavigationBar">
          <span className="NavigationBarLink">
            <a
              className="NavigationBarLink"
              href="https://lovdata.no/pro/#karnovLitteratur"
              target="_blank"
              rel="noopener noreferrer"
            >
              Faglitteratur
            </a>
          </span>
          <span className="NavigationBarSeperator">&gt;</span>
          <span className="NavigationBarLink">
            <a
              className="NavigationBarLink"
              href="https://lovdata.no/pro/#karnovLitteratur&legalArea=02"
              target="_blank"
              rel="noopener noreferrer"
            >
              Legal-Field
            </a>
          </span>
          <span className="NavigationBarSeperator">&gt;</span>
          <span className="NavigationBarLink">
            <a className="NavigationBarLink" href={lovdataBookLink} target="_blank" rel="noopener noreferrer">
              {props.bookInfo.title}
            </a>
          </span>
        </div>
      </div>
    </>
  );
}
